import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ButtonGroup } from 'primeng/buttongroup';
import { PaButtonComponent } from 'src/app/shared/ui-kit/pa-button/pa-button.component';
import { PaInfoBlockComponent } from 'src/app/shared/ui-kit/pa-info-block/pa-info-block.component';

@Component({
  selector: 'app-button-view',
  standalone: true,
  imports: [PaButtonComponent, PaInfoBlockComponent, ButtonGroup, ButtonModule],
  templateUrl: './button-view.component.html',
  styleUrls: ['./button-view.component.scss'],
})
export class ButtonViewComponent {
  lastClickedLabel = '';

  handlePaButtonClick(testLabel: string): void {
    this.lastClickedLabel = testLabel;
  }
}
